
import { defineComponent, ref, watch } from 'vue';
import useConfig from '@/composables/useConfig';

// import useTrainer from '@/composables/useTrainer';
import useTrainer from '@/composables/useTrainer';

import { useToast } from "vue-toastification";
import vue3slider from 'vue3-slider';

export default defineComponent({

	components: {
		"vue3-slider": vue3slider,
	},

	setup() {

		const toast = useToast()
		const config = useConfig()
		
		const { trainer, trainer_reset } = useTrainer();

		// trainer.start()

		const train_split_size_percentage = ref(70)
		config.validation.train_split_size = Math.ceil((train_split_size_percentage.value/100) * config.dataset.amount_rows);
		watch(train_split_size_percentage, (val) => {
			config.validation.train_split_size = Math.ceil((val/100) * config.dataset.amount_rows);

		})
		
		return {
			config,
			// trainer: { status: { progress: null, action: "", subaction: "" } },
			trainer,
			trainer_reset,

			trainer_start: () => {
				try {
					trainer.value.start()
				} catch(e) {
					toast.error((e as Error).message);
					// console.error("JHI", e)
				}
			},

			train_split_size_percentage,
/*
			train_split_size_percentage_model: {
				get() { 
					return 40;
					// return train_split_size_percentage.value;
				},
				set(val: string) {
					const portion: number = parseInt(val)
					console.log("set to ", val, "of", config.dataset.amount_rows)

					config.validation.train_split_size = Math.ceil((portion/100) * config.dataset.amount_rows);

					// train_split_size_percentage.value = portion;
				}
			}
*/
		}

	}

});
